import { render, staticRenderFns } from "./pageBanner.vue?vue&type=template&id=50b47a9d"
var script = {}
import style0 from "./pageBanner.vue?vue&type=style&index=0&id=50b47a9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports